import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthenticationGuard} from '@bndes/bndes-ux4/bn-seguranca';
import {EscolhaModalidadeGuard} from '../../interceptors/escolha-modalidade.guard';
import {ProdutosPermitidosPesquisa} from './pesquisa/produtos-permitidos-pesquisa';

const routes: Routes = [
  {
    path: 'produtos-permitidos/pesquisa',
    component: ProdutosPermitidosPesquisa,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProdutosPermitidosRoutingModule{}
